module.exports = __webpack_public_path__ + "img/rewind.b6d6cba6.svg";